import { useItemsListHelpers } from "@/components/ListingPages/ItemsLister/composables/itemsListHelpers/itemsListHelpers";
import itemsListerConfig from './config/itemsLister.config';

const {
  apiPathsConfig,
  filtersDisplayConfig,
  resultsManipulationCallback,
  entityItemsNamePlural,
  entityItemName
} = itemsListerConfig;

function useMediaListHelpers() {
  return useItemsListHelpers({
    apiPathsConfig,
    filtersDisplayConfig,
    resultsManipulationCallback,
    entityItemsNamePlural,
    entityItemName
  })
}


export default useMediaListHelpers;